import clsx from 'clsx';
import styles from './Logo.module.css';

interface LogoMarkProps {
  size?: number;
  /** Inverted colours, for the header over the hero photo. */
  inverted?: boolean;
  className?: string;
}

/** The Cardnd round mark. */
export function LogoMark({ size = 40, inverted = false, className }: LogoMarkProps) {
  return (
    <svg
      className={clsx(styles.mark, inverted && styles.inverted, className)}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      aria-hidden="true"
      focusable="false"
    >
      <circle className={styles.disc} cx="50" cy="50" r="50" />
      <path
        className={styles.glyph}
        transform="translate(22 29) scale(.56)"
        d="M18.9 75.1C5.8 73.1 -2.6 60.4 0.7 47.7C4.6 33.2 21.7 26.8 34.3 35.1C36 36.3 39 39.2 40.1 40.9C49 54.1 41.7 71.9 26.2 74.9C24.3 75.3 20.7 75.4 18.9 75.1ZM74.8 75.1C62.1 73.2 53.7 61 56.5 48.5C59.4 35.8 72.6 28.4 85 32.5C95.5 36.1 101.9 47.2 99.5 58.0C97 69.3 86.1 76.8 74.8 75.1ZM24.9 67.8C32.7 66.3 37.8 59 36.6 51.2C35.7 45.5 31.5 40.7 25.8 39.1C24.3 38.7 21.3 38.5 19.7 38.8C13.9 39.7 9.2 44 7.7 49.8C7.2 51.7 7.2 55.3 7.7 57.2C9.8 64.8 17.3 69.4 24.9 67.8ZM81.1 67.8C91.3 65.6 96 53.8 90.2 45.2C85.8 38.5 76.5 36.6 69.7 41.1C63.7 45.2 61.5 53.2 64.7 59.8C67.7 66 74.4 69.3 81.1 67.8ZM22.8 23.4C22.7 23.3 23.1 22.3 23.7 21.1C24.2 19.8 25.8 16.4 27.1 13.4C28.4 10.5 29.8 7.6 30.1 7.1C32 4 35.7 1.4 39.4 0.4L40.8 0.1L48.6 0.0C57.2 -0 57.9 0 60.3 0.8C63.5 1.8 66.5 4 68.4 6.9C69.1 8 77.1 23.1 77.1 23.3C77.1 23.4 75.3 23.5 73.1 23.5L69.1 23.5L68.9 23.0C68.7 22.8 67.2 19.9 65.4 16.5C62.4 10.8 62.1 10.4 61.3 9.6C60.3 8.6 59 7.8 57.7 7.5C56.4 7.1 42.3 7.1 41 7.4C39.6 7.8 38.3 8.6 37.3 9.6C36.2 10.7 36.3 10.5 32.6 18.7L30.5 23.4L26.7 23.4C24.6 23.4 22.8 23.4 22.8 23.4Z"
      />
    </svg>
  );
}

/** Mark + «Cardnd» wordmark (footer). */
export function Logo({ size = 36, wordSize = 22 }: { size?: number; wordSize?: number }) {
  return (
    <span className={styles.logo}>
      <LogoMark size={size} />
      <span className={styles.word} style={{ fontSize: wordSize }}>
        Cardnd
      </span>
    </span>
  );
}
